/* eslint-disable */
export const formatVersionLabel = (row) => {
    if (!row) {
        return '';
    }
    if (row.version) {
        return row.version;
    }
    const mayor = row.mayor ?? 0;
    const minor = row.minor ?? 0;
    const secuencial = row.secuencial ?? 0;
    return `${mayor}.${minor}.${secuencial}`;
};

export default formatVersionLabel;
